
type IconName =
  | 'search' | 'grid' | 'list' | 'sources' | 'preview' | 'code'
  | 'copy' | 'download' | 'plus' | 'info' | 'eye' | 'cam' | 'screen'
  | 'browser' | 'image' | 'media' | 'text' | 'color';

function createIcon(paths: Array<[string, ...any[]]>, w = 14, h = 14) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      width={w}
      height={h}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths.map((p, i) => {
        if (p[0] === 'circle') {
          return <circle key={i} cx={p[1]} cy={p[2]} r={p[3]} />;
        } else if (p[0] === 'rect') {
          return <rect key={i} x={p[1]} y={p[2]} width={p[3]} height={p[4]} rx={p[5] || 0} />;
        } else if (p[0] === 'path') {
          return <path key={i} d={p[1]} />;
        }
        return null;
      })}
    </svg>
  );
}

export const ICONS = {
  search: createIcon([['circle', 8.5, 8.5, 5.5], ['path', 'M 13.5 13.5 L 17 17']]),
  grid: createIcon([['rect', 2, 2, 7, 7, 1.5], ['rect', 11, 2, 7, 7, 1.5], ['rect', 2, 11, 7, 7, 1.5], ['rect', 11, 11, 7, 7, 1.5]]),
  list: createIcon([['rect', 2, 3, 16, 14, 2], ['path', 'M 2 8 h 16'], ['path', 'M 8 8 v 9']]),
  sources: createIcon([['path', 'M 4 6 h 12'], ['path', 'M 4 10 h 12'], ['path', 'M 4 14 h 7']]),
  preview: createIcon([['rect', 2, 3, 16, 12, 2], ['path', 'M 7 18 h 6'], ['path', 'M 10 15 v 3']]),
  code: createIcon([['path', 'M 6 7 l -4 3 4 3'], ['path', 'M 14 7 l 4 3 -4 3'], ['path', 'M 11 4 l -2 12']]),
  copy: createIcon([['rect', 8, 8, 10, 10, 1], ['path', 'M 4 14 H 3 a 1 1 0 0 1 -1 -1 V 3 a 1 1 0 0 1 1 -1 h 10 a 1 1 0 0 1 1 1 v 1']], 12, 12),
  download: createIcon([['path', 'M 10 3 v 10'], ['path', 'M 6.5 9.5 L 10 13 l 3.5 -3.5'], ['path', 'M 3 16 h 14']], 12, 12),
  plus: createIcon([['path', 'M 10 4 v 12'], ['path', 'M 4 10 h 12']], 12, 12),
  info: createIcon([['circle', 10, 10, 8], ['path', 'M 10 9 v 5'], ['path', 'M 10 7 h .01']]),
  eye: createIcon([['path', 'M 2 10 s 3 -6 8 -6 8 6 8 6 s -3 6 -8 6 -8 -6 -8 -6 z'], ['circle', 10, 10, 2]]),
  cam: createIcon([['path', 'M 2 7 h 10 a 1 1 0 0 1 1 1 v 5 a 1 1 0 0 1 -1 1 H 2 a 1 1 0 0 1 -1 -1 V 8 a 1 1 0 0 1 1 -1 z'], ['path', 'M 13 9 l 5 -3 v 8 l -5 -3']]),
  screen: createIcon([['rect', 2, 3, 16, 12, 2], ['path', 'M 7 18 h 6'], ['path', 'M 10 15 v 3']]),
  browser: createIcon([['circle', 10, 10, 8], ['path', 'M 2 10 h 16'], ['path', 'M 10 2 a 14 14 0 0 1 0 16'], ['path', 'M 10 2 a 14 14 0 0 0 0 16']]),
  image: createIcon([['rect', 2, 3, 16, 14, 2], ['path', 'M 2 13 l 4 -4 3 3 3 -3 6 5'], ['circle', 6.5, 7.5, 1.5]]),
  media: createIcon([['path', 'M 5 4 l 11 6 -11 6 V 4 z']]),
  text: createIcon([['path', 'M 4 5 h 12'], ['path', 'M 4 10 h 8'], ['path', 'M 4 15 h 5']]),
  color: createIcon([['circle', 10, 10, 8]]),
} as const;

export type { IconName };
